import React from 'react';
var CaretRight = function (_a) {
    var width = _a.width, height = _a.height, opacity = _a.opacity, fill = _a.fill;
    return (React.createElement("svg", { width: width, height: height, opacity: opacity, viewBox: "0 0 30 30" },
        React.createElement("polygon", { fill: fill, points: "9.45351896 0 24.453519 15 9.45351896 30 5.55 26.096481 16.6465765 15 5.55 3.90351896" })));
};
export default CaretRight;
